import React from 'react';
import ReactDOM from 'react-dom';

import VideoDOM from './videoDOM';


class StaticVideo extends React.Component{

	constructor(props){
		super(props);

		this.state = {	
			videoIsPlaying : false,
			src : this.props.src
		}
	}

	play(){
		this.refs.firstvideo.playVideo();
	}
	pause(){
		this.refs.firstvideo.pauseVideo();
	}

	componentDidMount(){
		if(this.props.isPlaying){
			this.props.mainPlay();
		}
		//console.log('chapter 1 is loaded' , this.props.isPlaying, this.state.autoplay);
	}


	//fire play from outside(main timeline)
	componentWillReceiveProps(nextProps){
		if(nextProps.isPlaying != this.state.videoIsPlaying){
				if(nextProps.isPlaying){

					//console.log('chapter 2 play');
					this.play();
				}else{
					//console.log('chapter 2 pause');
					this.pause();
				}
			this.setState({
				videoIsPlaying : nextProps.isPlaying
			});	
		}
	}

	render(){
		return (
			<main className="intro video-element">
				<div className="intro video-element-inner  active-video-0">
					<VideoDOM 
							src={this.state.src} 
							timeupdate ={this.props.timeupdate}
							ended={this.props.ended}
							name="video-0"
							ref="firstvideo"/>
				</div>
			</main>
			);
	}
}


export default StaticVideo;


// WEBPACK FOOTER //
// ./src/scripts/staticVideo.js